<div class="blocks-list-page">
  <div class="page-header">
    <div class="header-content">
      <h1>Blocages</h1>
      <p class="subtitle">Liste de tous les blocages entre utilisateurs</p>
    </div>
    <div class="header-count">
      @if (!loading()) {
      <span class="total-badge"
        >{{ blocks().length }} blocage{{ blocks().length !== 1 ? 's' : '' }}</span
      >
      }
    </div>
  </div>

  @if (loading()) {
  <div class="loading">
    <div class="spinner"></div>
    <p>Chargement des blocages...</p>
  </div>
  } @else if (error()) {
  <div class="error-message">
    <p>{{ error() }}</p>
    <button type="button" (click)="loadBlocks()">Réessayer</button>
  </div>
  } @else if (blocks().length === 0) {
  <div class="empty-state">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
    </svg>
    <h3>Aucun blocage</h3>
    <p>Il n'y a pas de blocage enregistré pour le moment.</p>
  </div>
  } @else {
  <div class="blocks-list">
    @for (block of blocks(); track block.id) {
    <div class="block-card">
      <div class="block-users">
        <div class="user-info blocker">
          <div class="user-avatar">
            @if (block.blocker.imgUrl) {
            <img [src]="block.blocker.imgUrl" [alt]="block.blocker.userName" loading="lazy" />
            } @else {
            <div class="avatar-placeholder">
              {{ block.blocker.userName.charAt(0).toUpperCase() }}
            </div>
            }
          </div>
          <div class="user-details">
            <span class="user-name">{{ block.blocker.userName }}</span>
            <span class="user-email">{{ block.blocker.email }}</span>
            <span class="user-role">a bloqué</span>
          </div>
        </div>

        <div class="block-arrow">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>

        <div class="user-info blocked">
          <div class="user-avatar">
            @if (block.blocked.imgUrl) {
            <img [src]="block.blocked.imgUrl" [alt]="block.blocked.userName" loading="lazy" />
            } @else {
            <div class="avatar-placeholder">
              {{ block.blocked.userName.charAt(0).toUpperCase() }}
            </div>
            }
          </div>
          <div class="user-details">
            <span class="user-name">{{ block.blocked.userName }}</span>
            <span class="user-email">{{ block.blocked.email }}</span>
            <span class="user-role">utilisateur bloqué</span>
          </div>
        </div>
      </div>

      <div class="block-reason">
        <span class="reason-label">Raison</span>
        <span class="reason-value">{{ block.reasonDisplayName || 'Non renseignée' }}</span>
        @if (block.description) {
        <p>{{ block.description }}</p>
        }
      </div>

      <div class="block-footer">
        <span class="block-date">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          {{ formatDate(block.createdAt) }}
        </span>
      </div>
    </div>
    }
  </div>
  }
</div>
